// extracted by mini-css-extract-plugin
export default {"page":"_0+kkYxOg8ftn1iErNkp7JU4Y5AY6rQb1Ru7HiNMHAwo="};